import { Button, Flex, HStack, useToast, VStack } from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup'
import { FieldError, useForm } from 'react-hook-form'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import * as yup from 'yup'
import { Input } from '../../../components/Form/Input'
import { User } from '../../../Interfaces/users'
import { api } from '../../../services/api'

const editUserSchema = yup.object().shape({
  name: yup.string().required('Nome obrigatório'),
  username: yup.string().required('Nome de usuário obrigatório'),
  email: yup.string().email('Necessário email válido').required('Campo email obrigatório'),
})

interface Props {
  id: string
  user?: User
}

export default function EditUser({ id, user: userData }: Props) {
  const toast = useToast()

  const queryClient = useQueryClient()

  const { register, handleSubmit, formState, reset } = useForm({
    resolver: yupResolver(editUserSchema),
  })

  const errors = formState.errors

  useQuery(['user-profile-initial', id], async () => userData as User, {
    enabled: Boolean(userData),
    onSuccess: (data) => {
      if (!data) return
      reset({ name: data.name, username: data.username, email: data.email })
    },
  })

  const updateUser = useMutation(
    async (payload: { name: string; username: string; email: string }) => {
      const response = await api.put(`users/${id}`, payload)

      if (response) {
        toast({ description: 'Usuário atualizado com sucesso', status: 'success' })
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['user', id])
      },
      onError: ({ response }) => {
        const errorList = response.data.errors

        const toastOptions = errorList.map((err) => ({ description: err.message, status: 'error' }))
        toastOptions.forEach((t) => {
          toast(t)
        })
      },
    },
  )

  const handleEditUser = async (data: any) => {
    const { name, username, email } = data
    await updateUser.mutateAsync({ name, username, email })
  }

  return (
    <>
      <form onSubmit={handleSubmit(handleEditUser)}>
        <VStack spacing="4" align="stretch">
          <HStack spacing="4">
            <Input label="Nome" {...(register('name') as any)} error={errors.name as FieldError} />
            <Input label="Nome de usuário" {...(register('username') as any)} error={errors.username as FieldError} />
          </HStack>

          <HStack spacing="4">
            <Input label="Email" {...(register('email') as any)} error={errors.email as FieldError} />
          </HStack>
          <Flex mt="8" justify="flex-end">
            <Button type="submit" colorScheme="pink" isLoading={Boolean(formState.isSubmitting)}>
              Salvar
            </Button>
          </Flex>
        </VStack>
      </form>
    </>
  )
}
